import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
// 引入 vue-baidu-map 插件
import BaiduMap from 'vue-baidu-map-3x'
// 引入 @vueuse/head 插件
import { createHead } from '@vueuse/head'

const app = createApp(App)
const head = createHead()
app.use(ElementPlus)
app.use(store)
app.use(router)
// 配置百度地图插件，传入 ak 密钥
app.use(BaiduMap, {
  ak: 'SNDyyg8f3SFOXyfSt2ph7MInlqkFsqgI'
})
// 使用 @vueuse/head 插件
app.use(head)
app.mount('#app')
